import React from "react";
import "./style/mapAdresse.css";
import Slider from "react-slick";
import map_noir from "../assets/footer/map.svg"
import telephone_noir from "../assets/footer/tel.svg"
import message_noir from "../assets/footer/message.svg"
import map_transparant from "../assets/footer/map-transparant.png"
import ReactSVG from 'react-svg'

import { compose } from 'redux'
import {
    withScriptjs,
    withGoogleMap,
    GoogleMap,
    Marker,
} from "react-google-maps";
const MapWithAMarker = compose(
    withScriptjs,
    withGoogleMap
)(props =>
    <GoogleMap
        defaultZoom={10}
        center={{ lat: props.lat, lng: props.lng }}
    >
        <Marker
            position={{ lat: props.lat, lng: props.lng }}
        />
    </GoogleMap>
);


class MapAddresse extends React.Component {
    constructor(props) {
        super();
        this.state = {
            lng: 10.30287,
            lat: 36.83272,

        };
    }
    changeMark(current) {
        if (current === 1) {
            /*local lac*/
            this.setState({ lat: 36.83272, lng: 10.30287 })

        } else if (current === 2) {
            /*local sousse*/
            this.setState({ lat: 35.820382, lng: 10.592063 })

        } else if (current === 3) {
            /*local paris*/
            this.setState({ lat: 48.802716, lng: 2.407108 })
        }
    }
    render() {
        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            customPaging: (i) => {
                return (
                    <li className="slick"><button onClick={() => { 
                        this.changeMark(i + 1) }}>{i}</button></li>
                );
            },
            slidesToScroll: 1,
            arrows: false,
        };

        return (
            <div>
                <div className="flex-container-map-adresse"> 
                    <div>
                        
                        <MapWithAMarker
                            googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCKlrfcRMEfo4uvdyDm_AFkq4M1gBQo64I&v=3.exp&libraries=geometry,drawing,places"
                            loadingElement={<div style={{ height: `100%` }} />}
                            containerElement={<div style={{ height: `400px` }} />}
                            mapElement={<div style={{ height: `100%` }} />}
                            lat={this.state.lat}
                            lng={this.state.lng}
                        />
                         
                    </div>

                    <div className="map_back">
                        <div className="divmapfooter"><img className="imagmappos" src={map_transparant} alt=""/></div>
                        <Slider style={{ "z-index": "3" }} {...settings}>
                            <div className="adrContent">
                                {/*Adresse1*/}
                                <div>
                                    <div><h2 className="adrName">Adresse</h2></div>
                                    <div style={{ display: "flex", paddingLeft: "20px", paddingRight: "20px" }}>
                                        <div style={{ marginTop: "-15px" }}>
                                            <ReactSVG style={{ width: "25px" }} src={map_noir} />
                                        </div>
                                        <div style={{ paddingLeft: "10px" }}>
                                            <p className="TextColor">30, rue Socrate Zone d’Activité Keïreddine LAC 3, Tunis 2060</p>
                                        </div>
                                    </div>

                                    <div style={{ display: "flex", paddingLeft: "20px" }}>
                                        <div style={{ alignSelf: "center", marginTop: "-15px" }}>
                                            <ReactSVG style={{ width: "25px" }} src={message_noir} />
                                        </div>
                                        <div style={{ paddingLeft: "10px" }}>
                                            <p className="TextColor">contact@chifco.com</p>
                                        </div>
                                    </div>

                                    <div style={{ display: "flex", paddingLeft: "20px" }}>
                                        <div style={{ alignSelf: "center", marginTop: "-15px" }}>
                                            <ReactSVG style={{ width: "25px" }} src={telephone_noir} />
                                        </div>
                                        <div style={{ paddingLeft: "10px" }}>
                                            <p className="TextColor">+216 73.82.09.30</p>
                                        </div>
                                    </div>

                                </div>
                            </div>


                            <div className="adrContent">
                                {/*Adresse2*/}
                                <div>
                                    <div><h2 className="adrName">Adresse</h2></div>
                                    <div style={{ display: "flex", paddingLeft: "20px" }}>
                                        <div style={{ marginTop: "-15px" }}>
                                            <ReactSVG src={map_noir} />
                                        </div>
                                        <div style={{ paddingLeft: "10px" }}>
                                            <p className="TextColor">Technopôle de Sousse, cité Hammam Maarouf,<br />Route ceinture de Sahloul, Sousse 4002</p>
                                        </div>
                                    </div>

                                    <div style={{ display: "flex", paddingLeft: "20px" }}>
                                        <div style={{ alignSelf: "center", marginTop: "-15px" }}>
                                            <ReactSVG src={message_noir} />
                                        </div>
                                        <div style={{ paddingLeft: "10px" }}>
                                            <p className="TextColor">Support@chifco.com</p>
                                        </div>
                                    </div>

                                    <div style={{ display: "flex", paddingLeft: "20px" }}>
                                        <div style={{ alignSelf: "center", marginTop: "-15px" }}>
                                            <ReactSVG style={{ width: "25px" }} src={telephone_noir} />
                                        </div>
                                        <div style={{ paddingLeft: "10px" }}>
                                            <p className="TextColor">+216 73.82.09.30</p>
                                        </div>
                                    </div>

                                </div>
                            </div>


                            <div className="adrContent">
                                {/*Adresse3*/}
                                <div>
                                    <div><h2 className="adrName">Adresse</h2></div>
                                    <div style={{ display: "flex", paddingLeft: "20px" }}>
                                        <div style={{ marginTop: "-15px" }}>
                                            <ReactSVG style={{ width: "25px" }} src={map_noir} />
                                        </div>
                                        <div style={{ paddingLeft: "10px" }}>
                                            <p className="TextColor">36 rue Edouard Vaillant, <br />Vitry-Sur-Seine, 94400, France</p>
                                        </div>
                                    </div>

                                    <div style={{ display: "flex", paddingLeft: "20px" }}>
                                        <div style={{ alignSelf: "center", marginTop: "-15px" }}>
                                            <ReactSVG style={{ width: "25px" }} src={message_noir} />
                                        </div>
                                        <div style={{ paddingLeft: "10px" }}>
                                            <p className="TextColor">contact@chifco.com</p>
                                        </div>
                                    </div>

                                    <div style={{ display: "flex", paddingLeft: "20px" }}>
                                        <div style={{ alignSelf: "center", marginTop: "-15px" }}>
                                            <ReactSVG style={{ width: "25px" }} src={telephone_noir} />
                                        </div>
                                        <div style={{ paddingLeft: "10px" }}>
                                            <p className="TextColor">+33 9 72 32 72 02</p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </Slider>
                        <div style={{ height: "30px", background: "#090770", opacity: "0" }}></div>
                    </div>

                </div>
            </div>

        );
    }
}
export default MapAddresse;


// WEBPACK FOOTER //
// ./src/home/mapAdresse.js